/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Executions That Occur Once the Snowflake Connection is Initialized
/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Results Written to the Store -> globalsStore()
export async function initializeSnowflakeQueries() {
  const { currentUser: storeCurrentUser, currentRole: storeCurrentRole, currentWarehouse: storeCurrentWarehouse } = storeToRefs(useSnowflakeAuthStore())

  // Get the Current Role and Warehouse for the Snowflake Connection
  const { data: settingsData, error: settingsError } = await useSnowflake({ query: 'SELECT CURRENT_USER() as "currentUser", CURRENT_ROLE() AS "currentRole", CURRENT_WAREHOUSE() AS "currentWarehouse", CONCAT(CURRENT_DATABASE(), \'.\', CURRENT_SCHEMA()) AS "currentNamespace"' })
  if (settingsError || !settingsData || settingsData.length < 1)
    return {}
  const { currentUser, currentRole, currentWarehouse, currentNamespace } = settingsData[0] as any

  storeCurrentRole.value = currentRole || ''
  storeCurrentWarehouse.value = currentWarehouse || ''

  console.log('Snowflake Initialized! Name:', currentUser, 'Default Role:', currentRole, 'Default Warehouse:', currentWarehouse, 'Default Namespace:', currentNamespace)

  // Get All Available Roles for User
  // const { data, error } = await useSnowflake({ query: 'SHOW GRANTS TO USER CURRENT_USER()' })

  // Return the Current Role and Warehouse
  return { currentRole, currentWarehouse }
}
